import base from './base'

const getLegalFunds = () => base
  .get('/legal_funds/').then(resp => resp.data)

export default {
  getLegalFunds: getLegalFunds,
}
